
const Section3 = ({ data }) => {

    return (
        <div className=" w-full flex justify-centers">
            <div className="2xl:container mx-auto py-12 sm:py-16 lg:py-[72px] md:px-10 lg:px-20  px-6">
                <div className=" pb-8 sm:pb-12 lg:pb-16 flex flex-col gap-6 items-center ">
                    <h1 className="text-24  sm:text-32  lg:text-48 text-primarycolor text-center  font-semibold  w-[90%]"> {data.Title}</h1>
                </div>
                <div className="flex flex-col lg:gap-20 gap-y-12">
                {
                    data.Contents.map((item, i) => (
                        <div key={i} className={`flex flex-col justify-between gap-y-4 items-center ${i%2==0?"lg:flex-row":"lg:flex-row-reverse"}`}>
                            <div className={`lg:w-1/2 w-full flex justify-center  ${i%2==0?"lg:justify-start":"lg:justify-end"}`}>
                                <img className=" w-full sm:w-[90%] lg:w-[80%]" src={process.env.PUBLIC_URL + item.img} alt="img" />
                            </div>
                            <div className="lg:w-1/2 w-full">
                                <h4 className="text-20 sm:text-24 lg:text-32 text-primarycolor font-semibold pb-8">{item.content.title}</h4>
                                <div className="flex flex-col gap-6">
                                  { item.content.para.map((data,index)=>(
                                    <div key={index} className="flex gap-3 items-start">
                                        <img className="mt-1 h-5 w-5 lg:h-6 lg:w-6" width={24} height={24}src={process.env.PUBLIC_URL + "/images/content/section2/Content Transformation/check icon.svg"} alt="icon" />
                                        <p className="text-14 sm:text-16 text-secondaryblack font-regular">{data.para1}</p>
                                    </div>))}
                                </div>
                            </div>

                        </div>
                    ))
                }
                </div>


            </div>
        </div>
    )

}
export default Section3;